export const isAnEmptyHtmlContent = (content) => {
  if (typeof content === 'string') {
    const regex = /<p>|<\/p>|<br>/g;

    const result = content.replaceAll(regex, '');

    return result.trim() === '';
  }
};
